var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.86 44.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-face_on") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.52,44.23c9.38-3.95,9.22-8,9.22-17.71,0-4.59.59-14.79-.77-18.5A12.09,12.09,0,0,0,32.74.09c-6.31-.2-12.94,0-19.29,0-5.21,0-10,2.13-12.15,7C-.59,11.43.14,19.94.14,25.16.14,31.89-.34,36.87,3.53,41s8.82,3.61,15.6,3.67l0-17.14-5.65,0-.12-6.66h5.78c0-4.54-.36-8.78,2.34-11.47,2.35-2.35,7.27-2.72,11.38-1.94v5.85c-5.78.58-7.21-1.92-6.84,7.58l6.54,0-.8,6.66H26V44.67c2.34-.07,7.72.28,9.48-.43Z",
    transform: "translate(0 0)",
    fill: "#4a66a2",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceIcon);
export default __webpack_public_path__ + "static/media/face_icon.87494427755f52606da116d4ad7fe036.svg";
export { ForwardRef as ReactComponent };